// Valida la consistencia de los datos { identification, first_name, last_name, last_name_two }
// extraídos por cualquiera de los lectores (PDF417, MRZ, licencia, código numérico) antes de
// propagarlos al formulario. Los lectores recortan espacios de relleno, pero los datos pueden
// conservar tildes y Ñ cuando el documento fuente las trae. Los MRZ (ICAO) solo usan A-Z, 0-9 y '<'.

// Cédula o código de licencia: alfanumérico, sin espacios. El mínimo de 5 caracteres
// descarta lecturas ruidosas de 1-2 caracteres; el máximo de 20 acota basura evidente sin afectar
// ningún identificador real (cédulas CR: 9 dígitos, licencias: 9 dígitos).
// Los pasaportes se validan aparte con PASAPORTE_REGEX cuando documentType === 'passport'.
export const IDENTIFICATION_REGEX = /^[A-Za-z0-9]{5,20}$/;
export const IDENTIFICATION_REGEX_CR = /^[0-9]{9,20}$/;
// Número de pasaporte ICAO TD3 (libreta, sin fillers '<'). Independiente del tenant.
export const PASAPORTE_REGEX = /^[A-Z0-9]{5,9}$/;

// Nombre(s) de pila: una o más palabras alfabéticas separadas por un solo espacio, sin espacios
// al inicio/final. Acepta tildes en vocales y Ñ.
// (ej. "JORGE ANTONIO", "MARIA JOSE").
const NAME_WORD = '[A-Za-zÁÉÍÓÚáéíóúÑñ]+';
export const FIRST_NAME_REGEX = new RegExp(`^${NAME_WORD}(?: ${NAME_WORD})*$`);

// Apellido: una o más palabras alfabéticas separadas por un solo espacio, sin espacios
// al inicio/final. Acepta tildes en vocales y Ñ.
export const SURNAME_REGEX = new RegExp(`^${NAME_WORD}(?: ${NAME_WORD})*$`);

function identificationRegexFor({ isCostaRica = false, documentType } = {}) {
  if (documentType === 'passport') return PASAPORTE_REGEX
  return isCostaRica ? IDENTIFICATION_REGEX_CR : IDENTIFICATION_REGEX
}

export function coerceInfraredData(data) {
  const {
    identification = '',
    first_name = '',
    last_name = '',
    last_name_two = '',
  } = data || {}

  return {
    identification,
    first_name: first_name && !FIRST_NAME_REGEX.test(first_name) ? '' : first_name,
    last_name: last_name && !SURNAME_REGEX.test(last_name) ? '' : last_name,
    last_name_two: last_name_two && !SURNAME_REGEX.test(last_name_two) ? '' : last_name_two,
  }
}

export function isConsistentInfraredData(data, options = {}) {
  const {
    identification = '',
    first_name = '',
    last_name = '',
    last_name_two = '',
  } = data || {};
  const identificationRegex = identificationRegexFor(options)
  if (!identificationRegex.test(identification)) return false;
  if (first_name && !FIRST_NAME_REGEX.test(first_name)) return false;
  if (last_name && !SURNAME_REGEX.test(last_name)) return false;
  if (last_name_two && !SURNAME_REGEX.test(last_name_two)) return false;

  return true;
}
